import {ContentfulSectionIntro} from '@github-ui/swp-core/components/contentful/ContentfulSectionIntro'
import {Section, Image} from '@primer/react-brand/esm'
import type {ModelsSectionContent} from '../../content'
import {Cards} from '../../_components/Cards/Cards'

import styles from './ModelsSection.module.css'

type Props = {
  contentfulContent: ModelsSectionContent
}

export function ModelsSection({contentfulContent}: Props) {
  const sectionId = contentfulContent.section.fields.htmlId
  const sectionIntro = contentfulContent.sectionIntro

  const visual = contentfulContent.visual
  const visualAsset = visual?.fields.media?.[0]?.fields.asset?.fields
  const visualFile = visualAsset?.file

  const cards = contentfulContent.cards

  return (
    <Section id={sectionId} fullWidth paddingBlockEnd="none">
      {sectionIntro ? <ContentfulSectionIntro component={sectionIntro} /> : null}

      {visualFile ? (
        <Section as="div" variant="gridline" paddingBlockStart="none" paddingBlockEnd="none" data-padding-inline="0">
          <Image
            className={styles.Visual}
            src={visualFile.url}
            width={visualFile.details?.image?.width}
            height={visualFile.details?.image?.height}
            alt={visualAsset.description || ''}
          />
        </Section>
      ) : null}

      {cards ? <Cards component={cards} /> : null}
    </Section>
  )
}
